import { take, put, all, select, takeEvery } from 'redux-saga/effects';


import {
  setMeta,
} from './actions';



export default function* metaRoot() {
  yield all([]);
}



// WEBPACK FOOTER //
// ./src/redux/meta/sagas.js